// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./MenuItemTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS */

.MenuItem-module__ListItem__MFItu {
    display: flex;
    flex: 1;
}

.MenuItem-module__Content__THTu9 {
    display: flex;
    flex: 1;
    gap: var(--ds-s);
    align-items: center;
    justify-content: space-between;
    max-width: calc(100% - var(--ds-l));
    padding: var(--ds-s) var(--ds-sm);
    border-radius: var(--ds-border-radius-s);
    cursor: pointer;

    &:focus-visible {
        outline: var(--ds-border-width-focus) solid
            var(--ds-menu-item-outline-color);
        outline-offset: -1px;
    }
}

.MenuItem-module__Disabled__Ztcwm {
    color: var(--ds-menu-item-disabled-color);
    cursor: default;
}

.MenuItem-module__Danger__GZR71 {
    color: var(--ds-menu-item-danger-color);

    &:hover {
        background-color: var(--ds-menu-item-danger-hover-bg-color);
    }
}

.MenuItem-module__Standard__aYhW4 {
    color: var(--ds-menu-item-color);

    &:hover {
        color: var(--ds-menu-item-hover-color);
        background-color: var(--ds-interaction-hover);
    }
}

.MenuItem-module__Active__xAR5L {
    color: var(--ds-menu-item-active-color);
    background-color: var(--ds-interaction-select);
}

.MenuItem-module__Leading__pFCel {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
    min-width: 0;
}

.MenuItem-module__Trailing__zfNuG {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
}

.MenuItem-module__Text__LImU5 {
    line-height: var(--ds-5x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ListItem": `MenuItem-module__ListItem__MFItu`,
	"Content": `MenuItem-module__Content__THTu9`,
	"Disabled": `MenuItem-module__Disabled__Ztcwm`,
	"Danger": `MenuItem-module__Danger__GZR71`,
	"Standard": `MenuItem-module__Standard__aYhW4`,
	"Active": `MenuItem-module__Active__xAR5L`,
	"Leading": `MenuItem-module__Leading__pFCel`,
	"Trailing": `MenuItem-module__Trailing__zfNuG`,
	"Text": `MenuItem-module__Text__LImU5`
};
export default ___CSS_LOADER_EXPORT___;
